import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { avatar, icon } from './ui';
import LogInModal from 'flarum/forum/components/LogInModal';
import Link from 'flarum/common/components/Link';
export default class ProfilePanel extends Component {
  profile = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadProfile();
  }
  async loadProfile() {
    const endpoint = String(app.forum.attribute('novatruckProfileApiUrl') || '').trim();
    const user = app.session.user;
    if (!endpoint || !user) return;
    try {
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('flarum_user_id', String(user.id()));
      const response = await fetch(url.toString(), {
        credentials: 'include',
        headers: {
          Accept: 'application/json'
        }
      });
      if (response.ok) this.profile = await response.json();
    } catch {
      this.profile = null;
    }
    m.redraw();
  }
  openLogin(event) {
    event.preventDefault();
    event.stopPropagation();
    try {
      app.modal.show(LogInModal, {});
    } catch {
      window.location.href = '/';
    }
    m.redraw();
  }
  view() {
    const user = app.session.user;
    const novaIdUrl = '/novaid';
    if (!user) {
      return m("section", {
        className: "NtCard NtProfile NtProfile--guest"
      }, m("div", {
        className: "NtCard-title"
      }, "Tw\xF3j profil"), m("div", {
        className: "NtGuestIcon"
      }, icon('fas fa-user-lock')), m("strong", null, "Zaloguj si\u0119 do spo\u0142eczno\u015Bci"), m("p", null, "Po\u0142\u0105cz konto z NovaID, aby zobaczy\u0107 dane postaci i osi\u0105gni\u0119cia."), m("button", {
        type: "button",
        className: "Button Button--primary NtProfile-login",
        onclick: event => this.openLogin(event)
      }, "ZALOGUJ SI\u0118"));
    }
    const username = user.displayName?.() || user.username();
    const playerUrl = `/u/${encodeURIComponent(user.slug?.() || user.username())}/gracz`;
    const profile = this.profile || {};
    return m("section", {
      className: "NtCard NtProfile"
    }, m("div", {
      className: "NtCard-head"
    }, m("div", {
      className: "NtCard-title"
    }, "Tw\xF3j profil"), m(Link, {
      className: "NtNovaId",
      href: novaIdUrl
    }, "Otw\xF3rz NovaID ", m("span", null))), m(Link, {
      className: "NtProfile-main",
      href: playerUrl
    }, m("div", {
      className: "NtProfile-avatar"
    }, avatar(user, {
      className: 'Avatar'
    }), m("span", {
      className: "NtProfile-presence"
    })), m("div", null, m("strong", {
      className: "NtProfile-name"
    }, username), m("span", {
      className: "NtProfile-level"
    }, "Poziom ", profile.level ?? '—'), m("span", {
      className: "NtProfile-online"
    }, m("i", null), " Online"))), m("div", {
      className: "NtProfile-stats"
    }, m(Link, {
      href: novaIdUrl
    }, m("span", null, "Got\xF3wka"), m("strong", null, this.formatCash(profile.cash))), m(Link, {
      href: playerUrl
    }, m("span", null, "Pojazdy"), m("strong", null, profile.vehicles ?? '—')), m(Link, {
      href: playerUrl
    }, m("span", null, "Osi\u0105gni\u0119cia"), m("strong", null, profile.achievements ?? '—'))));
  }
  formatCash(value) {
    if (value === undefined || value === null || value === '') return '—';
    const numeric = Number(value);
    return Number.isFinite(numeric) ? `$ ${new Intl.NumberFormat('pl-PL').format(numeric)}` : String(value);
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/ProfilePanel', ProfilePanel);